import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { requestGamesHomeDone, requestGamesHomeFailed, setGamesHome } from './gamesHome.action'

export interface State {
	isLoaded: boolean
	info?: any
}

export const defaultState: State = {
	isLoaded: false,
	info: undefined,
}

export default reducerWithInitialState<State>(defaultState)
	.cases([setGamesHome, requestGamesHomeDone], (state, payload) => ({
		...state,
		isLoaded: true,
		info: payload,
	}))
	.case(requestGamesHomeFailed, (state) => ({
		...state,
		isLoaded: true,
		info: undefined,
	}))
	.default((state) => state)